import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import img from "../images/categories/actors.jpeg";
import writer from "../images/categories/writers.jpeg";
import music from "../images/categories/music.jpeg";
import comedy from "../images/categories/comedy.jpeg";
import sports from "../images/categories/sports.jpeg";
import pub from "../images/categories/publish.jpeg";
import gaming from "../images/categories/gaming.png";
import digital from "../images/categories/digital.png";
import end from "../images/categories/ends.png";
import fashion from "../images/categories/fashion.jpeg";
import media from "../images/categories/media.jpeg";
import news from "../images/categories/news.jpeg";
import theatre from "../images/categories/theatre.jpeg";
import NavBar from "../NavBar/NavBar";
import { useEffect, useRef, useState } from "react";

// Temporary image map (replace later or make dynamic)
const categoryImages = {
  actors: img,
  music: music,
  sports: sports,
  comedy: comedy,
  writers: writer,
  publishing: pub,
  gaming: gaming,
  digital: digital,
  endorsements: end,
  media: media,
  fashion: fashion,
  news: news,
  theatre: theatre,
};

export default function RepresentationDetail() {
  const { categoryId } = useParams();
  const { t } = useTranslation("representationsdetail");
  const [lightNav, setLightNav] = useState(true);
  const heroRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setLightNav(entry.isIntersecting);
      },
      { threshold: 0.05 }
    );

    if (heroRef.current) observer.observe(heroRef.current);
    return () => observer.disconnect();
  }, []);

  const title = t(`categories.${categoryId}.title`, { defaultValue: "" });
  const description = t(`categories.${categoryId}.description`, {
    defaultValue: "",
  });

  if (!title) {
    return (
      <Box sx={{ px: 4, py: 10 }}>
        <Typography>Content not found.</Typography>
      </Box>
    );
  }

  const image = categoryImages[categoryId] || img;

  return (
    <Box sx={{ backgroundColor: "#F6F5F3", minHeight: "100vh" }}>
      <NavBar mode={lightNav ? "light" : "dark"} />
      {/* IMAGE HERO */}
      <Box
        sx={{
          position: "relative",
          height: { xs: "50vh", md: "65vh" },
          width: "100%",
          overflow: "hidden",
          backgroundColor: "#0B0B0B",
        }}
      >
        <Box
          ref={heroRef}
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "brightness(0.6)",
          }}
        />

        {/* TITLE */}
        <Box
          sx={{
            position: "absolute",
            bottom: { xs: 40, md: 80 },
            left: { xs: 24, md: 80 },
            right: { xs: 24, md: "auto" },
          }}
        >
          <Typography
            sx={{
              fontFamily: "Playfair Display",
              fontSize: { xs: "2.5rem", md: "4.5rem" },
              color: "#FFFFFF",
              fontWeight: 700,
              letterSpacing: "0.12em",
              textTransform: "uppercase",
            }}
          >
            {title}
          </Typography>
        </Box>
      </Box>

      {/* DESCRIPTION */}
      <Box
        sx={{
          maxWidth: 720,
          px: { xs: 3, md: 10 },
          py: { xs: 6, md: 10 },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Inter",
            fontSize: { xs: "1.05rem", md: "1.2rem" },
            lineHeight: 1.9,
            color: "#333333",
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
}
